<template>
  <Content title="成功客户案例" class="bg-light">
    <div
      id="caseCarousel"
      class="carousel slide th-pb-96"
      data-ride="carousel"
      data-interval="false"
    >
      <ol class="carousel-indicators">
        <li data-target="#caseCarousel" data-slide-to="0" class="indicator-item active"></li>
        <li data-target="#caseCarousel" data-slide-to="1" class="indicator-item"></li>
      </ol>
      <div class="carousel-inner th-pb-30">
        <div
          v-for="(colCase, colIndex) in cases"
          :key="colIndex"
          class="carousel-item"
          :class="{ active: colIndex === 0 }"
        >
          <div class="d-flex justify-content-between align-items-center bg-light">
            <div
              class="success-case-item th-py-34 bg-white"
              v-for="(caseItem, rowIndex) in colCase"
              :key="rowIndex"
            >
              <img :src="caseItem.image" />
              <div class="th-fs-18 th-mt-30">{{ caseItem.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
import { cases } from './data'
export default {
  name: 'DesktopSuccessCase',
  components: { Content },
  setup() {
    return {
      cases: [
        [cases[0], cases[1], cases[2]],
        [cases[3], cases[4], cases[5]],
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
// 覆盖bootstrap的预设样式
.indicator-item {
  box-sizing: content-box;
  width: 48px;
  height: 10px;
  background: #d8d8d8;
  border-radius: 7px;
  border: 0;
  opacity: 1;
}

.indicator-item.active {
  background: #4b7ef6;
}

.success-case-item {
  width: 345px;
  height: 470px;
  border-radius: 4px;
  overflow: hidden;
  padding: 40px;
}

.success-case-item img {
  height: 240px;
  width: 100%;
  object-fit: contain;
}
</style>
